import React from 'react';
import { Box, Skeleton, Container, Grid } from '@mui/material';

const BlacklistedSecuritiesSkeleton = () => {
  return (
    <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
      <Grid container spacing={2} alignItems="center">
        {/* Header Section */}
        <Grid size={{ xs: 12 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box sx={{ width: "40%" }}>
              <Box
                sx={{
                  marginBottom: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* Title Skeleton */}
                <Skeleton
                  variant="text"
                  width={200}
                  height={32}
                  sx={{ fontSize: "20px" }}
                />
                
                {/* Dropdown Skeleton */}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Skeleton
                    variant="rectangular"
                    width={120}
                    height={32}
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
              </Box>
            </Box>

            {/* Next Button Skeleton */}
            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
              <Skeleton
                variant="rectangular"
                width={150}
                height={40}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          </Box>
        </Grid>

        {/* Alert Box Skeleton */}
        <Grid size={{ xs: 12 }}>
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={60}
              sx={{ borderRadius: 1 }}
            />
          </Box>
        </Grid>

        {/* Table Skeleton */}
        <Grid size={{ xs: 12 }}>
          <Box sx={{ display: "flex", flexDirection: "row", width: "40%" }}>
            <Box sx={{ width: "100%" }}>
              {/* Table Header */}
              <Box sx={{ display: "flex", mb: 2 }}>
                <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
                <Skeleton variant="text" width={100} height={24} sx={{ mr: 2 }} />
                <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
                <Skeleton variant="text" width={200} height={24} />
              </Box>

              {/* Table Rows - Multiple rows to show scrollable content */}
              {Array.from({ length: 12 }).map((_, index) => (
                <Box key={index} sx={{ display: "flex", mb: 1 }}>
                  <Skeleton variant="text" width={80} height={20} sx={{ mr: 2 }} />
                  <Skeleton variant="text" width={100} height={20} sx={{ mr: 2 }} />
                  <Skeleton variant="text" width={80} height={20} sx={{ mr: 2 }} />
                  <Skeleton 
                    variant="text" 
                    width={Math.random() * 150 + 100} 
                    height={20} 
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default BlacklistedSecuritiesSkeleton; 